"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCardBanner = exports.transCarouselBanner = exports.transformBanner = exports.transformCouponInfo = exports.transformBannerSize = exports.WEB_MAXWIDTH = exports.WEB_MINWIDTH = void 0;
var banner_1 = require("../../utils/playground/banner");
var mutil_Language_1 = require("../../mobile/utils/mutil-Language");
var url_1 = require("../../utils/url");
exports.WEB_MINWIDTH = 1200;
exports.WEB_MAXWIDTH = 1920;
exports.transformBannerSize = function (_a) {
    var width = _a.width, height = _a.height, selfWidth = _a.selfWidth;
    var bannerWidth = banner_1.formatAspect(width || "");
    var bannerHeight = banner_1.formatAspect(height || "");
    var selfW = banner_1.formatAspect(selfWidth || "");
    var aspectRatio = bannerWidth ? (+bannerHeight / bannerWidth).toFixed(3) : 0;
    var nextBannerWidth = selfW || (bannerWidth > 1440 ? exports.WEB_MAXWIDTH : exports.WEB_MINWIDTH);
    return {
        width: nextBannerWidth,
        height: +aspectRatio * nextBannerWidth,
        aspectRatio: aspectRatio
    };
};
exports.transformCouponInfo = function (couponModule) {
    var _a;
    var res = {
        coupons: [],
        columnSize: 1
    };
    var coupons = [];
    if (!((_a = couponModule.module) === null || _a === void 0 ? void 0 : _a.coupons)) {
        return res;
    }
    (couponModule.module.coupons || []).map(function (item, index) {
        var img = mutil_Language_1.multilingualImgDisplay(item.info);
        coupons[index] = {
            img: img,
            code: item.couponCode
        };
    });
    return {
        coupons: coupons.filter(function (ele) { return !!(ele === null || ele === void 0 ? void 0 : ele.img); }),
        columnSize: couponModule.layout.columnNum
    };
};
exports.transformBanner = function (banner, floor, position) {
    return __assign(__assign({}, banner), { img: mutil_Language_1.multilingualImgDisplay(banner), link: floor && position ? url_1.genPrmLink(banner.link, { floor: floor, position: position }) : banner === null || banner === void 0 ? void 0 : banner.link });
};
exports.transCarouselBanner = function (elements, index) {
    return elements.reduce(function (m, i, idx) {
        return __spreadArrays(m, i.items.map(function (b) { return (__assign(__assign({}, b), { img: mutil_Language_1.multilingualImgDisplay(b), link: url_1.genPrmLink(mutil_Language_1.multilingualLinkDisplay(b), { floor: index + 1, position: idx + 1 }) })); }));
    }, []);
};
exports.transformCardBanner = function (elements, index) {
    return elements.map(function (ele, idx) {
        return {
            items: ele.items.map(function (b) {
                return __assign(__assign({}, b), { img: mutil_Language_1.multilingualImgDisplay(b), link: url_1.genPrmLink(mutil_Language_1.multilingualLinkDisplay(b), { floor: index + 1, position: idx + 1 }) });
            })
        };
    });
};
